import { ProductCategoryNames } from './case';

export enum NotificationLevels {
    Success = 1,
    Info = 2,
    Warning = 3,
    Error = 4,
}

export interface INotification {
    code: string;
    level: string;
    notificationLevel?: NotificationLevels;
    notificationLevelStr: string;
    description: string;
    category: string;
    endDate?: Date;
}

    export interface INotificationResponse {
        Notifications: INotification[];
    }

    export interface INotificationContext {
    tenantId: string;
    tenantDisplayName: string;
    items: INotificationContextItem[];
  }

  export interface INotificationContextItem {
    id: number;
    entityId?: any;
    entityTypeId?: any;
    icon?: any;
    message: string;
    scopeObjectId: string;
    scopeType: string;
    regardingMemberId?: any;
    expireOn: string;
    createdOn: Date;
    isDismissable: boolean;
    dismissedOn?: any;
    dismissedBy?: any;
    createdBy?: any;
    type?: any;
    severity: string;
    subject?: string;
    tenant?: string;
    tenantDisplayName?: string;
    from: string;
    scopeIcon: string;
    active?: boolean;
    status?: string;
    ref?: any;
    dateProcessed?: boolean;
    itemMessage?: Array<{type: 'text'|'button', value?: string, buttonType?: string}>
  }

    export class Notifications extends Array<INotification> {

    constructor(notifications: INotification[]) {
        super(...(notifications && Array.isArray(notifications) ? notifications.map(notification => {
            const result = {...notification};
            switch (result.level) {
                case 'success':
                    result.notificationLevel = NotificationLevels.Success;
                    result.notificationLevelStr = `success`;
                    break;
                case 'info':
                    result.notificationLevel = NotificationLevels.Info;
                    result.notificationLevelStr = `info`;
                    break;
                case 'warning':
                case 'warn':
                    result.notificationLevel = NotificationLevels.Warning;
                    result.notificationLevelStr = `warn`;
                    break;
                case 'error':
                    result.notificationLevel = NotificationLevels.Error;
                    result.notificationLevelStr = `error`;
                    break;
            }

            return result;
        }) : []) );
    }

    static getGreaterNotificationLevel(notifications: INotification[]): NotificationLevels {
        if (notifications && notifications.length > 0) {
            const sort = (a, b) => a.notificationLevel < b.notificationLevel ? 1 : -1;
            return [...notifications].sort(sort)[0].notificationLevel;
        }

        return null;
    }

    static getNotificationsByLevel(level: NotificationLevels, notifications: INotification[]): INotification[] {
        return notifications ? notifications.filter(notification => notification.notificationLevel === level) : [];
    }

    public static getNotificationsHighestLevel(notifications: INotification[]): NotificationLevels {
        return Notifications.getGreaterNotificationLevel(notifications);
    }

    public getNotificationsByCode(code: string): INotification {
        return this.find(notification => notification.code === code);
    }
}
